import { axiosInstance } from "../../../../axios/axiosInstance";
import { LANDING_API_URL, getDefaultHeaders } from "../../../../config";

const authHeaders = (extra = {}) => {
  const authToken = localStorage.getItem("authToken");
  return {
    ...getDefaultHeaders(),
    Authorization: `Bearer ${authToken}`,
    ...extra,
  };
};

export const getApplicants = (dateRange = {}) =>
  axiosInstance.get(`${LANDING_API_URL}/career-applicants`, {
    headers: authHeaders(),
    params: dateRange,
  });

export const addApplicantRequest = (formData) =>
  axiosInstance.post(`${LANDING_API_URL}/career-applicants`, formData, {
    headers: authHeaders({ "Content-Type": "multipart/form-data" }),
  });

export const updateApplicantRequest = (id, applicantData) =>
  axiosInstance.post(
    `${LANDING_API_URL}/career-applicants/${id}`,
    applicantData,
    {
      headers: authHeaders({ "Content-Type": "multipart/form-data" }),
    },
  );

export const removeApplicant = (applicantId) =>
  axiosInstance.delete(`${LANDING_API_URL}/career-applicants/${applicantId}`, {
    headers: authHeaders(),
  });
